import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const reportsRoutes: Routes = [
  {
    path: 'mva-gfap-analysis',
    loadComponent: () =>
      import('./mva-gfap-analysis/mva-gfap-analysis.component').then(
        (m) => m.MVAGFAPAnalysisComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cnesst-frequency',
    loadComponent: () =>
      import('./cnesst-frequency/cnesst-frequency.component').then(
        (m) => m.CNESSTFrequencyComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'business-analysis',
    loadComponent: () =>
      import('./business-analysis/business-analysis.component').then(
        (m) => m.BusinessAnalysisComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-reports/:gridId',
    loadComponent: () =>
      import('./dynamic-reports/dynamic-reports.component').then(
        (m) => m.DynamicReportsComponent
      ),
    canActivate: [AuthGuard],
  },
];
